<template>
  <div>
    <crud-layout-search
      ref="crudLayoutSearch"
      :params="params"
      :interface="nmInterface"
      :id="id"
      :page="page"
      multiselect
      clean-layout
      class="clientGenerator"
      maximized
    >
      <page-table
        slot="page-table"
        slot-scope="dataPageTable"
        v-bind="dataPageTable"
        @action-button="dataPageTable.actionButton"
        @show-message="dataPageTable.showMessage"
      >
        <jt-data-table
          slot="table"
          slot-scope="dataTable"
          ref="jtDataTableRef"
          v-bind="dataTable"
          multiselect
          selection-force
          class="table-crud"
          :row-buttons="false"
          @action-button="
            (_event, _clickedRecord, _jtDataTableComponent) =>
              onActionClickMain(
                _event,
                _clickedRecord,
                _jtDataTableComponent,
                dataTable.actionButton
              )
          "
          @show-message="dataTable.showMessage"
          @selection="(_event) => onSelectRowMain(_event)"
          @toggle-change="(_event) => onToggleChange(_event)"
        >
        </jt-data-table>
      </page-table>

      <page
        slot="page"
        slot-scope="{ params, forms, showMessage, actionButton }"
        :params="params"
        :forms="forms"
        @action-button="actionButton"
        @show-message="showMessage"
      >
        <template slot="form" slot-scope="{ form, actionClick }">
          <jt-dynamic-form
            v-if="form.name == 'clientGenerator.gravar' || form.name == 'clientGenerator.alterar'"
            ref="clientGeneratorGravar"
            :form="form"
            :model="form.dadosForm"
            :inputs="inputForm(form)"
            :interface="form.nmInterface"
            :relacionamentos="form.relacionamentos"
            form-class="form"
            class="client-generator-form"
            @search-found="onSearchFound(form)"
          />
          <jt-dynamic-form
            v-else
            ref="clientGeneratorPage"
            :form="form"
            :model="form.dadosForm"
            :inputs="form.inputs"
            :interface="form.nmInterface"
            :relacionamentos="form.relacionamentos"
            form-class="form"
            class="client-generator-form"
            @search-found="onSearchFound(form)"
          />
          <crud-form
            ref="crudForm"
            :form="form"
            :model="form.dadosForm"
            @action-click="actionClick"
          >
            <compositions :hideCompositions="hiddenCompositions(form)" style="margin-top: -35vh; margin-bottom: 15vh;" >
              <composition slot="residues" slot-scope="dados" v-bind="dados">
                <template slot="table" slot-scope="dadosTable">
                  <div class="q-mb-md text-bold">
                    <translate>SELECT_RESIDUES_CLIENT_GENERATOR</translate>
                  </div>
                  <jt-data-table v-bind="dadosTable"
                                multiselect
                                selection-force
                                rowKey="boundResidue"
                                :row-buttons="false"
                                :columnEdit="paintCell"
                                @selection="_event => onSelectRow(_event, form, dadosTable)"
                                @action-button="dadosTable.actionButton"
                                @show-message="dadosTable.showMessage"
                                @click-row="dadosTable.clickRow"
                                @toggle-change="onToggleChange(form)" />
                </template>
              </composition>
              <composition slot="clientGeneratorResidues"
                          slot-scope="dados"
                          v-bind="dados" >
                <template slot="table"
                          slot-scope="dadosTable">
                  <jt-data-table v-bind="dadosTable"
                                noneselect
                                rowKey="boundResidue"
                                :columnEdit="paintCell"
                                @action-button="(_event, _clickedRecord, _jtDataTableComponent) => onActionClick(_event, _clickedRecord, _jtDataTableComponent, form, dadosTable.actionButton)"
                                @show-message="dadosTable.showMessage"
                                @click-row="dadosTable.clickRow" />
                </template>
              </composition>
            </compositions>
          </crud-form>
        </template>
      </page>
    </crud-layout-search>

    <modal v-if="environmentalAgencyAccountModal.show" ref="environmentalAgencyAccountRef" :show="environmentalAgencyAccountModal.show"
      v-bind="environmentalAgencyAccountModal" @input="(show) => (environmentalAgencyAccountModal.show = show)"
      @action-button="createOrUpdateEnvironmentalAgencyAccount" />

    <q-dialog v-if="modalConfigs.flModal" v-model="modalConfigs.flModal">
      <q-layout
        view="Lhh lpR fff"
        container
        class="bg-white modal-medium clientGeneratorModal"
      >
        <q-header class="bg-primary">
          <q-toolbar>
            <q-toolbar-title>{{ modalConfigs.name }}</q-toolbar-title>
            <q-btn v-close-popup flat round dense size="1.5em" icon="cancel" />
          </q-toolbar>
        </q-header>
        <div class="cg-content">
          <q-page-container class="card-container-modal">
            <div v-if="modalConfigs.isEmpty" class="text-center my-center">
              <div class="text-h5 text-center q-mb-lg">
                <translate>RESIDUES_GENERATOR_EMPTY_MESSAGE_PART_1</translate
                ><br />
                <translate>RESIDUES_GENERATOR_EMPTY_MESSAGE_PART_2</translate>
              </div>
            </div>
            <div v-else>
              <div class="q-mb-md text-bold">
                <translate>SELECT_RESIDUES_CLIENT_GENERATOR</translate>
              </div>
              <jt-data-table
                id="jtdt-client-generator"
                multiselect
                selection-force
                :api-mode="false"
                :data="modalConfigs.data"
                :buttons="modalConfigs.datatable.buttons"
                :fields="modalConfigs.datatable.columns"
                :columnEdit="paintCell"
                @selection="onSelectRowJTDT"
                @toggle-change="onToggleChangeJTDT"
              />
            </div>
          </q-page-container>
        </div>
        <q-footer class="text-center bg-white q-pb-xl">
          <div id="buttons-when-empty" v-if="modalConfigs.isEmpty">
            <q-btn class="q-px-xl" color="dark" @click="closeModal">
              <translate>RESIDUES_GENERATOR_EMPTY_MESSAGE_RETURN</translate>
            </q-btn>
          </div>
          <div id="buttons-when-not-empty" v-else>
            <q-btn class="q-px-xl q-mr-lg" color="dark" @click="closeModal">
              <translate>RESIDUES_GENERATOR_EMPTY_MESSAGE_CANCEL</translate>
            </q-btn>
            <q-btn
              ref="icAddSelectedResiduesIntoComposition"
              disable
              class="q-px-xl"
              color="info"
              @click="icAddSelectedResiduesIntoComposition"
            >
              <translate>RESIDUES_GENERATOR_EMPTY_MESSAGE_INSERT</translate>
            </q-btn>
          </div>
        </q-footer>
      </q-layout>
    </q-dialog>
  </div>
</template>

<script>
import { Component, Vue, Watch } from 'vue-property-decorator'
import { JtCrud, JtDataTable } from 'jtech-webcomps'
import { repository } from 'jtech'
import moment from 'moment'
import { throws } from 'assert'
import ClientGeneratorResidueDialog from './ClientGeneratorResidueDialog'

const {
  page,
  pageTable,
  CrudLayoutSearch,
  form,
  input,
  compositions,
  composition,
  modal
} = JtCrud
@Component({
  mixins: [page],
  components: {
    CrudLayoutSearch,
    page,
    pageTable,
    JtDataTable,
    'crud-form': form,
    'crud-input': input,
    compositions,
    composition,
    modal
  },
  props: {
    id: String,
    interface: String,
    name: String
  }
})
class ClientGenerator extends Vue {
  modalConfigs = {
    flModal: false,
    isEmpty: false
  };

  selectedRecords = [];
  selectedIds = [];
  residueIds = [];
  clientGeneratorIdsActivateOrInactivate = [];
  environmentalAgencyAccountModal = { show: false };

  mounted () {
    try {
      this.$refs.crudLayoutSearch.onButton(
        'icActivateInBlock',
        this.icActivateInBlock
      )
      this.$refs.crudLayoutSearch.onButton(
        'icInactivateInBlock',
        this.icInactivateInBlock
      )
      this.$refs.crudLayoutSearch.onButton(
        'btEnvironmentalAgencyAccount',
        this.openEnvironmentalAgencyModal
      )
    } catch (error) {
      console.error(error)
    }
  }

  @Watch('environmentalAgencyAccountModal.show')
  onChangeEnvironmentalAgencyAccountModalShow () {
    this.$refs.jtDataTableRef.refresh()
  }

  async createOrUpdateEnvironmentalAgencyAccount (action, params) {
    if (params.id) {
      await repository.update('environmentalAgencyAccount.alterar', params)
    } else {
      await repository.create('environmentalAgencyAccount.gravar', params)
    }
    this.environmentalAgencyAccountModal = { ...this.environmentalAgencyAccountModal, show: false }
  }

  handleEnvironmentalAgencyAccountForm (form, row) {
    form[0].dadosForm.clientGenerator = row.params.id
    const input = form[0].inputs.find(i => i.name === 'password')
    if (input) {
      input.type = 'password'
      input.dataType = 'password'
    }
  }

  async openEnvironmentalAgencyModal (row, action) {
    const environmentalAgencyAccountId = row.params.environmentalAgencyAccount
    const form = await this.getEnironmentalAgencyFormLayout(environmentalAgencyAccountId)
    this.handleEnvironmentalAgencyAccountForm(form, row)
    this.environmentalAgencyAccountModal = {
      show: true,
      forms: form,
      label: this.$gettext('ENVIRONMENTAL_AGENCY_ACCOUNT'),
      parent: this
    }
  }

  async getEnironmentalAgencyFormLayout (environmentalAgencyAccountId) {
    if (!environmentalAgencyAccountId) {
      return await repository.resolve('environmentalAgencyAccount.gravar')
    } else {
      return await repository.resolve('environmentalAgencyAccount.alterar', { idAcaoGrid: environmentalAgencyAccountId, id: environmentalAgencyAccountId })
    }
  }

  icActivateInBlock (button) {
    this.dialogUpdateAvailableInBlock(true)
  }

  icInactivateInBlock (button) {
    this.dialogUpdateAvailableInBlock(false)
  }

  onActionClickMain (
    _event,
    _clickedRecord,
    _jtDataTableComponent,
    _actionButton
  ) {
    const { name, label } = _event
    switch (name) {
      case 'icActivateInBlock':
        this.dialogUpdateAvailableInBlock(true)
        break
      case 'icInactivateInBlock':
        this.dialogUpdateAvailableInBlock(false)
        break
      default:
        _actionButton(_event, _clickedRecord, _jtDataTableComponent)
        break
    }
  }

  dialogUpdateAvailableInBlock (available) {
    if (this.clientGeneratorIdsActivateOrInactivate.length == 0) {
      this.$q.dialog({
        title: this.$gettext(
          'IS_CLIENTE_GENERATOR_RESIDUE_AVAILABLE_BLOCK_NO_REGISTERS'
        ),
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: false
      })
      return
    }

    const title = this.$gettextInterpolate(
      this.$gettext('IS_CLIENTE_GENERATOR_RESIDUE_AVAILABLE_BLOCK'),
      {
        action: available
          ? this.$gettext('ACTIVATE_MSG')
          : this.$gettext('INACTIVATE_MSG')
      }
    )
    this.$q
      .dialog({
        title: title,
        component: ClientGeneratorResidueDialog,
        parent: this,
        confirm: true
      })
      .onOk(async () => {
        const param = {
          available: available,
          ids: this.clientGeneratorIdsActivateOrInactivate
        }
        await repository.resolveLogic(
          'clientGenerator.updateAvailableInBlock',
          param
        )
        this.$refs.crudLayoutSearch.refresh()
      })
  }

  onSelectRowMain (_event) {
    this.clientGeneratorIdsActivateOrInactivate = []
    _event.forEach((_selectedRecord) => {
      this.clientGeneratorIdsActivateOrInactivate.push(_selectedRecord.id)
    })
  }

  get nmInterface () {
    return this.interface
  }

  get page () {
    return page
  }

  hiddenCompositions (_form) {
    return this.isGravar(_form) ? ['clientGeneratorResidues'] : []
  }

  inputForm (_form) {
    const generatorInput = _form.inputs.find(
      (input) => input.model == 'generator'
    )
    if (!generatorInput) {
      throw new 'Não foi encontrado generatorInput'()
    }
    generatorInput.type = 'generator_search'
    return _form.inputs.filter(
      (_input) =>
        !['clientGeneratorResidues', 'residues', 'generatorDocuments'].includes(
          _input.model
        )
    )
  }

  async getResiduesByGenerator (_generator) {
    const params = {
      generator: _generator,
      residueIds: []
    }
    params.residueIds = this.residueIds

    const { registros } = await repository.resolveDatatableModel(
      'boundResidue.searchForResidueGeneratorsInContract',
      params
    )

    return registros
  }

  async loadCompositionByGenerator (_dadosForm) {
    if (!_dadosForm.generator) {
      _dadosForm.residues = []
    } else {
      const residues = await this.getResiduesByGenerator(_dadosForm.generator)

      residues.forEach(_residue => {
        _residue.compactor = false
        _residue.checked = false
        _residue.boundResidue = _residue.id
        _residue.available = true
      })

      _dadosForm.residues = residues
    }
  }

  async getModalForms () {
    return await repository.resolve(
      'clientGeneratorResidue.compositionAdd',
      {}
    )
  }

  getModalDatatable (_form) {
    return _form.inputs.find((_input) => _input.type == 'DATATABLE')
  }

  async getModalResidues (_form) {
    const params = {
      generator: _form.dadosForm.generator,
      excludeIds: [],
      residueIds: []
    }

    params.residueIds = this.residueIds

    _form.dadosForm.clientGeneratorResidues.forEach(_residue => {
      params.excludeIds.push(_residue.boundResidue)
    })

    const { registros } = await repository.resolveDatatableModel(
      'boundResidue.searchForResidueGeneratorsInContract',
      params
    )

    registros.forEach((_residue) => {
      _residue.compactor = false
      _residue.available = true
    })

    return registros
  }

  async getModalConfiguration (_label, _form) {
    const forms = await this.getModalForms()
    const datatable = this.getModalDatatable(forms[0])
    const residues = await this.getModalResidues(_form)

    return {
      forms,
      datatable,
      name: _label,
      params: {},
      data: residues,
      flModal: true,
      isEmpty: residues.length <= 0
    }
  }

  async openModal (_label, _form) {
    this.modalConfigs = await this.getModalConfiguration(_label, _form)
  }

  async icAddRecordOnComposition (_label, _form) {
    await this.openModal(_label, _form)
  }

  icRemoveRecordOnComposition (_clickedRecord, _form) {
    const newResidues = []

    _form.dadosForm.clientGeneratorResidues.forEach(_residue => {
      if (_residue.boundResidue !== _clickedRecord.boundResidue) {
        _residue.__index = newResidues.length
        newResidues.push(_residue)
      }
    })

    _form.dadosForm.clientGeneratorResidues = newResidues
  }

  icAddSelectedResiduesIntoComposition () {
    this.selectedRecords.forEach((_selectedRecord) => {
      this.$refs.crudForm.form.dadosForm.clientGeneratorResidues.push(
        _selectedRecord
      )
    })
    this.closeModal()
  }

  closeModal () {
    this.modalConfigs.flModal = false
    this.selectedRecords = []
  }

  getIdsFromSelectedRows (_event, _dadosForm) {
    const selectedIds = []
    _event.forEach((_selectedRecord) => {
      selectedIds.push(_selectedRecord.id)
    })
    _dadosForm.residues.forEach((_residue) => {
      _residue.checked = selectedIds.includes(_residue.id)
    })
  }

  getMomentFormatted () {
    return moment().format('YYYY-MM-DD kk:mm:ss.SSSSSS')
  }

  addSettingsToCmpositionObjectWhenUpdate (_compositionObject, _residue) {
    _compositionObject = {
      ..._residue,
      ..._compositionObject
    }

    delete _compositionObject.id

    return _compositionObject
  }

  configurateCompositionObjectToSave (_residue, _index, isUpdate = false) {
    let compositionObject = {
      clientGenerator: null,
      compactor: _residue.compactor,
      available: _residue.available,
      createdAt: this.getMomentFormatted(),
      flAlterado: 'N',
      boundResidue: _residue.boundResidue,
      updatedAt: this.getMomentFormatted(),
      __index: _index
    }

    if (isUpdate) {
      compositionObject = this.addSettingsToCmpositionObjectWhenUpdate(
        compositionObject,
        _residue
      )
    }

    return compositionObject
  }

  isGravar (_form) {
    return _form.nmInterface == 'clientGenerator.gravar'
  }

  prepareCompositionToBeSaved (_form) {
    const _dadosForm = _form.dadosForm

    if (this.isGravar(_form)) {
      _dadosForm.clientGeneratorResidues = []
      let indexAux = 0
      _dadosForm.residues.forEach((_residue) => {
        if (_residue.checked) {
          const selectedRecord = this.configurateCompositionObjectToSave(
            _residue,
            indexAux
          )
          _dadosForm.clientGeneratorResidues.push(selectedRecord)
          indexAux++
        }
      })
    } else {
      _dadosForm.clientGeneratorResidues.forEach((_residue, _index) => {
        _residue.updatedAt = this.getMomentFormatted()
        _residue.flAlterado = true
      })
    }
  }

  setUpCell (_color, _value) {
    return `<div class="${_color + ' '}q-pa-sm">${_value}</div>`
  }

  paintQuantityRemaining (_cell) {
    const { quantityRemainingCGRColor, quantityRemainingCGR } = _cell.props.row
    return quantityRemainingCGRColor
      ? this.setUpCell(quantityRemainingCGRColor, quantityRemainingCGR)
      : false
  }

  paintWasteCertified (_cell) {
    const { wasteCertifiedCadriNumberCGRColor, wasteCertifiedCadriNumberCGR } =
      _cell.props.row
    return wasteCertifiedCadriNumberCGRColor
      ? this.setUpCell(
        wasteCertifiedCadriNumberCGRColor,
        wasteCertifiedCadriNumberCGR
      )
      : false
  }

  paintCell (_cell) {
    switch (_cell.col.name) {
      case 'quantityRemainingCGR':
        return this.paintQuantityRemaining(_cell)
      case 'wasteCertifiedCadriNumberCGR':
        return this.paintWasteCertified(_cell)
      default:
        return false
    }
  }

  async onSearchFound (_form) {
    this.residueIds = _form.dadosForm.residueIds
    if (this.isGravar(_form)) {
      await this.loadCompositionByGenerator(_form.dadosForm)
    }
  }

  async onActionClick (
    _event,
    _clickedRecord,
    _jtDataTableComponent,
    _form,
    _actionButton
  ) {
    const { name, label } = _event
    switch (name) {
      case 'icAddRecordOnComposition':
        await this.icAddRecordOnComposition(label, _form)
        break
      case 'icRemoveRecordOnComposition':
        this.icRemoveRecordOnComposition(_clickedRecord, _form)
        break
      default:
        break
    }

    _actionButton(_event, _clickedRecord, _jtDataTableComponent)
  }

  onSelectRow (_event, _form, _dadosTable) {
    this.getIdsFromSelectedRows(_event, _form.dadosForm)
    this.prepareCompositionToBeSaved(_form)
    _dadosTable.selection(_event)
  }

  onToggleChange (_form) {
    this.prepareCompositionToBeSaved(_form)
  }

  onSelectRowJTDT (_event) {
    this.selectedRecords = []
    this.selectedIds = []
    let indexAux =
      this.$refs.crudForm.form.dadosForm.clientGeneratorResidues.length

    _event.forEach(_selectedRecord => {
      _selectedRecord.checked = true
      const selectedRecordAux = this.configurateCompositionObjectToSave(_selectedRecord, indexAux, true)
      this.selectedIds.push(selectedRecordAux.boundResidue)
      this.selectedRecords.push(selectedRecordAux)
      indexAux++
    })

    this.$refs.icAddSelectedResiduesIntoComposition.disable =
      this.selectedRecords.length <= 0
  }

  onToggleChangeJTDT (_event) {
    if (this.selectedIds.includes(_event.props.row.id)) {
      this.selectedRecords.forEach(_selectedRecord => {
        if (_selectedRecord.boundResidue === _event.props.row.id) {
          _selectedRecord.compactor = _event.newValue
        }
      })
    }
  }
}
export default ClientGenerator
</script>

<style lang="stylus" scoped>
/deep/ .icInativar { button {
  width: auto;
}}

/deep/ .icAtivar { button {
  width: auto;
}}

.clientGeneratorModal {
  .cg-content {
    padding: 15px;
  }

  .my-center {
    margin: 25% 0;
  }
}

.client-generator-form {
  height: auto !important;

  #scroll-area {
    height: 25vh !important;
  }
}

.clientGenerator {
  padding-top: 20px;

  .buttons-top-crud {
    display: none;
  }

  .label-crud-search {
    display: none;
  }

  .btNovo-btn i, .icAlterar-btn i, .icAtivar-btn i, .icInativar-btn i {
    padding-right: 10px;
  }

  .crudButtons .card-crud .table-crud .jt-datatable {
    height: 63vh !important;
  }
}
</style>
